export function isIconAccessoryProp(accessory) {
    return typeof accessory === 'string' || typeof accessory === 'function';
}
//# sourceMappingURL=isIconAccessoryProp.js.map